import * as React from 'react';

type UseElementHeightCssVarParams = {
  ref: React.RefObject<HTMLElement | null>;
  cssVarName: string;
  enabled?: boolean;
};

export const useElementHeightCssVar = ({ ref, cssVarName, enabled = true }: UseElementHeightCssVarParams) => {
  React.useEffect(() => {
    if (!enabled) {
      return;
    }

    const node = ref.current;

    if (!node) {
      return;
    }

    const updateHeightVar = () => {
      const height = node.getBoundingClientRect().height;

      if (height > 0) {
        document.documentElement.style.setProperty(cssVarName, `${height}px`);
      }
    };

    updateHeightVar();

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(() => updateHeightVar());

      observer.observe(node);

      return () => {
        observer.disconnect();
        document.documentElement.style.removeProperty(cssVarName);
      };
    }

    window.addEventListener('resize', updateHeightVar);

    return () => {
      window.removeEventListener('resize', updateHeightVar);
      document.documentElement.style.removeProperty(cssVarName);
    };
  }, [cssVarName, enabled, ref]);
};
